export default [{
    dictKey: '',
    dictValue: '全部'
}, {
    dictKey: '0',
    dictValue: '待执行'
}, {
    dictKey: '1',
    dictValue: '执行中'
},{
    dictKey: '2',
    dictValue: '成功'
},{
    dictKey: '3',
    dictValue: '失败'
},];



// WEBPACK FOOTER //
// ./src/service/constant/EmptyStatus.js